export default {
  btn: 'Loslegen',
  typeform_code: 'BCsU4z6u',
  // btn_link: 'https://plth3cirri9.typeform.com/to/xrg4tquB',
  toggle_en: 'Sprache auf English ändern',
  toggle_de: 'Sprache auf Deutsch ändern',
  talent: {
    title: 'Talents',
    nav: [
      {
        name: 'Top Sales Jobs finden',
        link: '/jobs',
        icon: 'BriefcaseIcon',
      },
      {
        name: 'Mehr über HYRE',
        link: 'https://landing.hyretalents.com/sales/finde-deinen-naechsten-job?utm_source=Website&utm_medium=Organic&utm_campaign=5140_Corporate_website',
        icon: 'SpeakerPhoneIcon',
      },
    ],
    blog: {
      title: 'Aktuelle Artikel',
      cta: '',
      cta_link: '',
      post: [
        {
          name: 'Dein Sales Guide: Diese Positionen gibt es in der Sales Branche',
          link: 'https://blog.hyretalents.com/post/sales-positionen-bedeutung',
        },
        {
          name: 'Der perfekte Lebenslauf für deine nächste Bewerbung im Vertrieb',
          link: 'https://blog.hyretalents.com/post/lebenslauf-vertrieb',
        },
        {
          name: '6 Tipps, wie du dein nächstes Vorstellungsgespräch im Vertrieb rockst',
          link: 'https://blog.hyretalents.com/post/vorstellungsgespraech-vertrieb',
        },
      ],
    },
  },
  customer: {
    title: 'Firmen',
    nav: {
      service: {
        name: 'Unser Service',
        link: 'section-service',
        intro: '',
        icon: 'IconTemplate',
      },
      how: {
        name: 'So funktionierts',
        link: 'section-how',
        intro: '',
        icon: 'IconChartBar',
      },
      compare: {
        name: 'Vergleich',
        link: 'section-compare',
        intro: '',
        icon: 'IconCalculator',
      },
      testimonial: {
        name: 'Kundenstimmen',
        link: 'section-testimonial',
        intro: '',
        icon: 'IconBadgeCheck',
      },
    },
    cta: [
      {
        name: 'Termin buchen',
        link: 'https://calendly.com/hyre-sales-team/intro',
        icon: 'IconPhone',
      },
    ],
  },
}
